import { CloudflareAsset } from "@/shared/common/enums";
import type { IButtonTypes, TButtonSize } from "@/shared/common/types";
import { CloudFlareImage } from "@/shared/components";
import { Button } from "@ab.uitools/ui-library/components/Button";
import type { ISVGIconProps } from "@ab.uitools/ui-library/components/SVGIcons/types";
import { useTranslation } from "react-i18next";

interface Props {
  action: () => void;
  type?: IButtonTypes;
  buttonText?: string;
  className?: string;
  size?: TButtonSize;
}

export const BackButton = ({
  action,
  type,
  buttonText,
  size,
  className
}: Props) => {
  const { t } = useTranslation();

  return (
    <Button
      type={type || `text`}
      className={`back-button ${className}`}
      size={size || "small"}
      onClick={action}
      data-testid="back-button"
      data-ga-id="back-button"
      data-ga-action="Back to previos page"
      iconProps={{
        Component: (props: ISVGIconProps) => (
          <CloudFlareImage {...props} path={CloudflareAsset.ArrowShortLeft}/>
        ),
        alignment: "left",
      }}
    >
      {t(buttonText || "general.previousPage")}
    </Button>
  );
};
